import React from 'react';
import { Text } from '../../text/text';
import styles from './featureTogglesSavedMessage.css';
export const FeatureTogglesSavedMessage = ({ text, }) => (React.createElement("div", { className: styles.FeatureTogglesSavedMessage },
    React.createElement(Text, null, text)));
